import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { convertDateStringToObj } from "@whoosh/utilities/src/dates";

import { useShouldShowCancelButton_memberPackage$key } from "./__generated__/useShouldShowCancelButton_memberPackage.graphql";

export const useShouldShowCancelButton = (
  memberPackageRef:
    | useShouldShowCancelButton_memberPackage$key
    | null
    | undefined
) => {
  const memberPackage = useFragment(
    useShouldShowCancelButtonFragmentString,
    memberPackageRef
  );
  if (!memberPackage) {
    return false;
  }

  const isAlreadyCancelled = memberPackage.cancelledOn !== null;
  const isReoccurring = memberPackage.package?.billingType === "SUBSCRIPTION";
  const hasEnded = memberPackage.endsOn
    ? convertDateStringToObj(memberPackage.endsOn) < new Date()
    : false;

  return isReoccurring && !isAlreadyCancelled && !hasEnded;
};

const useShouldShowCancelButtonFragmentString = graphql`
  fragment useShouldShowCancelButton_memberPackage on MemberPackage {
    cancelledOn
    endsOn
    package {
      billingType
    }
  }
`;
